import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth/authSlice';

import DashboardReducer from './Redux/AdminSlices/Dashboardsclice';
import SalesDashboardReducer from './Redux/AdminSlices/SalesDashboardSlice';

import AffiliateDashboardReducer from './Redux/AffiliateSlices/dashboardsclice';

import AffiliateReferralsReducer from './Redux/AffiliateSlices/ReferralSclice';

import AffiliateProfileSliceReducer from './Redux/AffiliateSlices/ProfileSlice';

import AdminuserSliceReducer from './Redux/AdminSlices/userslice';

import AdminAffiliateSliceReducer from './Redux/AdminSlices/AffiliateSlice';

import AdminReferralSliceReducer from './Redux/AdminSlices/ReferralRequestSlice';

import ProtestExamptionsliceReducer from './Redux/AdminSlices/ProtestSlice';

import RefundInvoiceSliceReducer from './Redux/AdminSlices/RefundInvoiceSlice';

import dminwithdrarequestSliceReducer from './Redux/AdminSlices/withdrawrequestslice';

import AdminVersionApiSliceReducer from './Redux/AdminSlices/VersionSlice';

import ChatSliceReducer from './Redux/AdminSlices/Chatslice';

import NotificationSliceReducer from './Redux/AdminSlices/NotificationSlice';

import trainingLibrarySliceReducer from './Redux/AdminSlices/traininglibrarySlice';

import CouponsSliceReducer from './Redux/AdminSlices/CouponsSlice';

import CampaignSliceReducer from './Redux/AdminSlices/campainigSclice';

import propertiesSliceReducer from './Redux/AdminSlices/propertisslice';

import homesteadSliceReducer from './Redux/AdminSlices/homesctedSlice';

// SuperAdmin RBAC slices
import usersReducer from './Redux/SuperAdminSlice/userSlice';
import rolesReducer from './Redux/SuperAdminSlice/RolesSlice';
import permissionsReducer from './Redux/SuperAdminSlice/permissionSlice';
import roleassignedReducer from './Redux/SuperAdminSlice/RoleassignedSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,

    adminDashboard: DashboardReducer,
    salesDashboard: SalesDashboardReducer,

    affiliateDashboard: AffiliateDashboardReducer,

    affiliatereferrals: AffiliateReferralsReducer,

    AffiliateProfile: AffiliateProfileSliceReducer,

    Adminuserlist: AdminuserSliceReducer,

    AdminAffiliatelist: AdminAffiliateSliceReducer,

    referralrequest: AdminReferralSliceReducer,

    protestAndExamptions: ProtestExamptionsliceReducer,

    refundInvoices: RefundInvoiceSliceReducer,

    Adminwithdrarequest: dminwithdrarequestSliceReducer,

    VersionApi: AdminVersionApiSliceReducer,

    chat: ChatSliceReducer,

    notifications: NotificationSliceReducer,

    trainingLibrary: trainingLibrarySliceReducer,

    coupons: CouponsSliceReducer,

    campaign: CampaignSliceReducer,

    properties: propertiesSliceReducer,

    homestead: homesteadSliceReducer,

    // SuperAdmin RBAC reducers
    RolesSlice: rolesReducer,

    permissions: permissionsReducer,

    roleAssigned: roleassignedReducer,

    users: usersReducer,
  },
});
